import MasterNav from '@patsnap-biz/master-nav';
import {
    SEARCH_NAV_CONFIG,
    TOOL_NAV_LIST, 
    CAS_SEARCH,
    TELECOM_SEARCH,
    PATENT_SEARCH_NAV_LIST,
    HISTORY_QUERY_NAV_LIST,
    AI_LAB_LIST,
    type NavItem,
    type ToolNavList,
} from '../components/search-left-nav/config';
import getSearchInit from '../apis/search_init_api/searchInit.js';
import _ from 'lodash';
import { Site } from '@patsnap-utils/biz';
import { proxyDefaultValue } from 'library-@/componentZPrefaceProxy/proxyDefaultValue';

const { forEach, map, remove, findIndex, find, clone } = _;
const navService = new MasterNav.NavService();
navService.partitions = [];

interface LabData {
    anchor: string;
    app_id: string;
    staging: string;
    used: boolean;
    user_id: string;
}
interface SearchTab extends NavItem {
    labData: LabData
}

// 专利搜索的NAV信息
const getPatentSearchNavs = (searchTabs: SearchTab[], permissions: { [key: string] : boolean | LabData }) => {

    const originSearchList = clone(searchTabs) || [];
    const hasExpert = permissions?.combineSearch || false;
    const legalCaseLabData: LabData = permissions?.legalCase as LabData;
    const showLegalCase = permissions?.showLegalCase || false;

    if (showLegalCase && legalCaseLabData) {
        const legalIndex = findIndex(originSearchList, {
            key: 'legalSearch'
        });
        if (legalIndex !== -1 && legalCaseLabData.staging === 'approved' && legalCaseLabData.used) {
            originSearchList.splice(legalIndex + 1, 0, {
                key: 'legalCase',
                labData: legalCaseLabData
            });
        }
    }

    // 所有的search tabs
    const searchNavs = map(originSearchList,
        (item) => {
            const label = `snapBusiness.headerV2.searchTabs.${item.key}`;
            item = { ...SEARCH_NAV_CONFIG[item.key], ...item, label };
            return item;
        });


    const patentSearchNavs = PATENT_SEARCH_NAV_LIST;

    const searchItem = find(patentSearchNavs, { key: 'search' });
    if (searchItem) {
        searchItem.children = searchNavs;
        //如果没有expert权限，需要隐藏专家检索
        if (!hasExpert) {
            remove(searchItem.children, nav => {
                return nav.key === 'expertSearch';
            });
        }
    }
    return patentSearchNavs;
}

// 历史语句
const getHistoryQueryNavs = ({ saveQuery, cas }) => {
    //如果没有Saved query权限，需要隐藏菜单栏
    const historyNavList = HISTORY_QUERY_NAV_LIST;
    const mySearchItem = find(historyNavList, { key: 'my_searches' });
    if ( mySearchItem?.children) {
        if (!saveQuery) {
            remove(mySearchItem.children, nav => {
                return nav.key === 'savedSearches';
            });
        }
    
        if (!cas) {
            remove(mySearchItem.children, nav => {
                return nav.key === 'savedCASSearches';
            });
        }
    }
    return historyNavList;
}

// 通信
const getTelecomNavs = () => {
    return TELECOM_SEARCH;
}

// cas
const getCasNavs = () => {
    return CAS_SEARCH;
}

export async function getSearchNavList({ isSpecialIp, siteRegion }) {
    const searchNavList: NavItem[] = [];

    // 获取权限、搜索tab信息
    const { initData, searchTabs } = await getSearchInit();
    const permissions = initData?.permissions || {};
    permissions.showLegalCase = ((siteRegion || proxyDefaultValue.siteRegion) === 'CN') && !(isSpecialIp || proxyDefaultValue.isSpecialIp);

    const patentSearchNavs = getPatentSearchNavs(searchTabs, permissions);
    searchNavList.push(...patentSearchNavs);

    //特殊IP登陆的只有search菜单
    const isSpecialIpLogin = isSpecialIp || proxyDefaultValue.isSpecialIp;
    if (!isSpecialIpLogin) {

        if (permissions.telecom) {
            const telecomNavs = getTelecomNavs();
            searchNavList.push(...telecomNavs);
        }

        if (permissions.cas) {
            const casNavs = getCasNavs();
            searchNavList.push(...casNavs);
        }

        const historyNavs = getHistoryQueryNavs(permissions);
        searchNavList.push(...historyNavs);

    }
        
    if (permissions.aiLab && !searchNavList.find(item => item.key === 'aiLab')) {
        searchNavList.unshift(...AI_LAB_LIST);
    }

    return assignNavItemLink(searchNavList);
}

export function getToolNavList({ isSpecialIp }) {
    // FIXME: Search已不存在zPREFACE
    const isSpecialIpLogin = isSpecialIp || proxyDefaultValue.isSpecialIp;
    if (isSpecialIpLogin) {
        return [];
    }
    return assignNavItemLink(TOOL_NAV_LIST);
}

const assignNavItemLink = (navList: ToolNavList) => {
    forEach(navList, (item) => {
        if (typeof item !== 'string') {
            if (item.pathKey) {
                item.label = item.label ? item.label : `commonNav.${item.key}`;
                item.fullPath = `${new Site({ sld: item.pathKey }).href}/${item.url}`;
            }
            if (item.children) {
                assignNavItemLink(item.children);
            }
        }
    });
    return navList;
};

export default navService;
